import { Field, useFormikContext } from 'formik';
import { t } from 'i18next';
import React from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';

const ReferTo = () => {
	const { errors, touched } = useFormikContext();
	const fields = [
		{
			label: 'VISIT.DR_NAME',
			name: 'referTo.drName',
			type: 'text',
			placeholder: t('VISIT.ENTER_DR_NAME'),
			errorField: 'drName',
		},
		{
			label: 'VISIT.MOBILE_NUMBER',
			name: 'referTo.mobile',
			type: 'tel',
			placeholder: t('VISIT.ENTER_MOBILE'),
			errorField: 'mobile',
		},
		{
			label: 'VISIT.EMAIL_ID',
			name: 'referTo.email',
			type: 'email',
			placeholder: t('VISIT.ENTER_EMAIL'),
			errorField: 'email',
		}
	];

	return (
		<Row className='my-3'>
			<Card.Title>{t('VISIT.REFER_TO')}</Card.Title>
			<Row>
				{fields.map((field) => (
					<Col md={4} key={field.name}>
						<Form.Label>{t(field.label)}</Form.Label>
						<Field name={field.name}>
							{({ field: formField }) => (
								<Form.Control
									{...formField}
									value={formField.value || ''}
									type={field.type}
									placeholder={field.placeholder}
								/>
							)}
						</Field>
						{errors.referTo?.[field.errorField] && touched.referTo?.[field.errorField] && (
							<Form.Text className="text-danger mb-2 d-block">
								{errors.referTo[field.errorField]}
							</Form.Text>
						)}
					</Col>
				))}
			</Row>
		</Row>
	);
};

export default ReferTo;